export const MEASURE_ACTIVE_POINT = 'measure_control_active_point'
export const MEASURE_POINT_COLD = 'measure_control_point_cold'
export const MEASURE_LINE_HOT = 'measure_control_line_hot'
export const MEASURE_LINE_COLD = 'measure_control_line_cold'
export const MEASURE_LABEL_HOT = 'measure_control_label_hot'
export const MEASURE_LABEL_COLD = 'measure_control_label_cold'
export const MEASURE_AREA_COLD = 'measure_control_area_cold'
export const MEASURE_AREA_HOT = 'measure_control_area_hot'
export const MEASURE_AREA_HOT_OUTLINE = 'measure_control_area_hot_outline'
